import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import startInDomain, { MAX_LIST_START } from "@ext/markdown/elements/list/edit/models/orderList/logic/startInDomain";

const orderedList: NodeSerializerSpec = async (state, node) => {
	const start = startInDomain(node.attrs.start);
	const marker = (i: number, otherMarker = false) =>
		`${Math.min(start + i, MAX_LIST_START)}${otherMarker ? ")" : "."} `;
	// CommonMark lets only a list starting at 1 interrupt a paragraph: written tight under the item's
	// text, any other start reads as that text in GitLab or VS Code, so it keeps the blank line.
	if (start !== 1 && state.inTightList && state.closed?.type !== node.type) state.flushClose(2);
	await state.renderList(
		node,
		(i) => " ".repeat(marker(i).length),
		(i, otherMarker) => marker(i, otherMarker),
	);
};

export default orderedList;
